"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { v4 as uuidv4 } from "uuid";

export default function AnalyticsTracker() {
	const pathname = usePathname();
	const searchParams = useSearchParams();

	useEffect(() => {
		const trackPageView = async () => {
			try {
				// Get or create session ID
				let sessionId = localStorage.getItem("analytics_session_id");
				if (!sessionId) {
					sessionId = uuidv4();
					localStorage.setItem("analytics_session_id", sessionId);
				}

				// Get search query if exists
				const searchQuery = searchParams.get("q");

				// Check if this is a product detail page
				const isProductPage = pathname.startsWith("/products/");
				const productSlug = isProductPage ? pathname.split("/").pop() : null;

				// If it's a product page, get the product ID first
				let productId = null;
				if (isProductPage && productSlug) {
					const response = await fetch(`/api/products/${productSlug}`);
					if (response.ok) {
						const product = await response.json();
						productId = product.id;
					}
				}

				// Track the page view
				await fetch("/api/analytics", {
					method: "POST",
					headers: {
						"Content-Type": "application/json",
					},
					body: JSON.stringify({
						type: isProductPage ? "PRODUCT_VIEW" : "PAGE_VIEW",
						pageUrl: pathname,
						searchQuery,
						sessionId,
						productId,
					}),
				});
			} catch (error) {
				console.error("Failed to track page view:", error);
			}
		};

		trackPageView();
	}, [pathname, searchParams]);

	return null; // This component doesn't render anything
}
